import React from 'react';
import '../styles/Header.css';
import logo from '../assets/img/Logo.png';

type Props = { onOpenGallery: () => void };

const Header: React.FC<Props> = ({ onOpenGallery }) => {
    return (
        <header className="hero-header">
            <div className="header-content container d-flex flex-column align-items-center text-center">
                <img src={logo} alt="Baldų Sintezė logotipas" className="company-logo mb-3" />
                <h1 className="display-6 text-white mb-2">Baldų Sintezė</h1>
                <p className="lead text-white">
                    Kiekvienas baldas prasideda nuo jūsų vizijos. Mes pasirūpiname, kad ji virstų realybe –
                    kokybiškai, stilingai ir laiku.
                </p>

                <button className="btn btn-danger mt-3" onClick={onOpenGallery}>
                    Mūsų darbai
                </button>
            </div>
        </header>
    );
};

export default Header;
